import { FormattedMessage } from 'react-intl';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CancelUrl, { COMPONENT_STYLE } from '../../../components/CancelUrl/CancelUrl';
import AnnouncementPopup from '../../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import Button, {BUTTON_STYLE} from '../../../../shared-components/Button/Button';
import './DoubleConsent.less';
import PageHeaderText from '../../../../shared-components/Typography/PageHeaderText';
import TextOverflow from '../../../../shared-components/Typography/TextOverflow';
import { uniqueTimestampId } from '../../../../framework/App/AppUtils';

const LOCALE_PREFIX = 'US/pages/TermsPage/DoubleConsent';

export class DoubleConsent extends Component {
    static propTypes = {
        email: PropTypes.string.isRequired,
        onAgree: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired,

        // Passed in props
        handleCancel: PropTypes.func
    };

    constructor() {
        super();

        // agreed variable used to prevent a fast double-click
        // action resulting in handleSubmit being called twice
        this.agreed = false;

        this.state = {
            isButtonDisabled: false
        };
    }

    handleSubmit = event => {
        capeLog && capeLog(`double prompt submit button click: agreed=${this.agreed} isButtonDisabled=${this.state.isButtonDisabled} timestamp=${uniqueTimestampId()}`);

        if (this.agreed || this.state.isButtonDisabled) {
            return;
        }

        this.agreed = true;
        this.setState({
            isButtonDisabled: true
        });

        this.props.onAgree(event);
    };

    render() {
        const {
            email,
            onHide,
            handleCancel
        } = this.props;
        const { isButtonDisabled } = this.state;

        const footer = (
            <div id="DoubleConsent">
                <div className="body-content">
                    <div id="action-buttons" className="buttons">
                        <Button
                            data-automation-id="doubleConsentSubmit"
                            id="doubleConsentSubmit"
                            btnStyle={BUTTON_STYLE.PP_PRIMARY}
                            className="bmlAgreeToTerms"
                            onClick={this.handleSubmit}
                            disabled={isButtonDisabled}
                        >
                            <FormattedMessage id={`${LOCALE_PREFIX}.agree-apply`} />
                        </Button>
                        <CancelUrl
                            componentType={COMPONENT_STYLE.LINK_BUTTON}
                            onClick={handleCancel}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <AnnouncementPopup
                footer={footer}
                id="confirm-popup"
                onClose={onHide}
                ariaDescribedById="justToConfirm"
            >
                <PageHeaderText>
                    <FormattedMessage id={`${LOCALE_PREFIX}.confirm-sub-header`} />
                </PageHeaderText>

                <ul className="text-left">
                    <li>
                        <FormattedMessage id={`${LOCALE_PREFIX}.confirm-content-first`} />
                    </li>
                    <li>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.confirm-content-second`}
                            values={{
                                email: <TextOverflow>{email}</TextOverflow>
                            }}
                        />
                    </li>
                </ul>
            </AnnouncementPopup>
        );
    }
}

export default DoubleConsent;
